
define('jst!peoplefinder/_blank_slate',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="is-blank-slate">\n  <p>\n    <%= typeof message === \'undefined\' ? t("We couldn\'t find people matching your search #peoplefinder ") : message %>\n  </p>\n</div>\n');
 });

